import type { TableColumnConfig } from '@pct-ng/feature-table-material';

/**
 * Updates the provided list of table column configurations to make specified columns sortable.
 *
 * @param {TableColumnConfig<T>[]} columns - The array of column configurations to update.
 * @param {readonly (keyof T)[]} sortable - A readonly array of keys representing the columns that should be sortable.
 * @return {TableColumnConfig<T>[]} The updated array of column configurations with sortable properties applied.
 */
export function setSortableColumns<T>(
  columns: TableColumnConfig<T>[],
  sortable: readonly (keyof T)[],
): TableColumnConfig<T>[] {
  return columns.map(column => {
    if (sortable.includes(column.id as keyof T)) {
      column.sortable = true;
    }
    return column;
  });
}
